export const language: any = {
    LabelFavorites: "पसंदीदा",
    LabelYouDontHaveRecipeAddYourFavoriteRecipe: `आपके पास अभी तक कोई पसंदीदा व्यंजन नहीं है।<br/>अपने पसंदीदा व्यंजन जोड़ें!`,
    LabelDoYouWantUnSave: `क्या आप इस रेसिपी को अनसेव करना चाहते हैं?`,
    save: "सहेजें",
    unsave: "सहेजें",
    OkFavorite: "हाँ",
    CloseFavorite: "नहीं",
};

